import {Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, TextField} from "@mui/material";
import {dateToString} from "../../Utils/dateUtils";
import {delayTransferMembership} from "../../../API/changePersonJob";
import {toast} from "react-toastify";
import {Form, Formik} from "formik";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers-pro";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {LoadingButton} from "@mui/lab";
import * as React from "react";
import {useEffect, useRef} from "react";
import {Close} from "@mui/icons-material";

const DelayTransferMembershipModal = (props) => {
    const {
        changeJob,
        open,
        handleClose
    } = props;
    const formRef = useRef(null);

    useEffect(() => {
        if (changeJob) {
            formRef?.current?.setFieldValue('tentative_transfer_date', changeJob.tentative_transfer_date);
        }
    }, [changeJob]);

    return (
        <div>
            <Dialog open={open} onClose={(_event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose(false);
                }
            }} scroll="paper" fullWidth maxWidth={"md"}>
                <DialogTitle>Delay Transfer</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose(false)}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <Close/>
                </IconButton>
                <DialogContent>
                    <Formik
                        innerRef={formRef}
                        initialValues={{
                            tentative_transfer_date: null
                        }}
                        validate={(values) => {
                            const errors = {};

                            if (!values.tentative_transfer_date) {
                                errors.tentative_transfer_date = 'Required';
                            }

                            return errors;
                        }}
                        onSubmit={(values, {setSubmitting}) => {
                            let postData = {};
                            postData.tentative_transfer_date = dateToString(new Date(values.tentative_transfer_date), 'yyyy-MM-dd');

                            delayTransferMembership(changeJob.person_job_change_id, postData).then((res) => {
                                if (res) {
                                    toast.success("Transfer membership has been delayed");
                                    handleClose(true);
                                }

                                setSubmitting(false);
                            }).catch((error) => {
                                setSubmitting(false);
                                toast.error(error.message);
                            });
                        }}>
                        {({isSubmitting, values, setFieldValue, errors}) => (
                            <Form>
                                <Grid container
                                      sx={{
                                          padding: "20px",
                                          textAlign: "left",
                                          display: "flex",
                                          justifyContent: "center"
                                      }}
                                      spacing={3}>
                                    <Grid item xs={5}>
                                        <LocalizationProvider
                                            dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                name="tentative_transfer_date"
                                                label='Tentative date of transfer*'
                                                inputFormat='dd/MM/yyyy'
                                                className='custom-datepicker'
                                                value={values.tentative_transfer_date} // Set the initial value
                                                onChange={(newValue) => {
                                                    setFieldValue("tentative_transfer_date", newValue);
                                                }}
                                                renderInput={(startProps) => (
                                                    <>
                                                        <TextField
                                                            {...startProps}
                                                            sx={{
                                                                width: "100%",
                                                            }}
                                                            padding={{
                                                                top: "1px",
                                                            }}
                                                            error={
                                                                errors.tentative_transfer_date
                                                            }
                                                        />
                                                    </>
                                                )}
                                            />
                                            <div
                                                style={{
                                                    color: "red",
                                                    fontSize: "0.75rem",
                                                    margin: "4px 14px 0px",
                                                }}
                                            >
                                                    <span>
                                                        {errors.tentative_transfer_date}
                                                    </span>
                                            </div>
                                        </LocalizationProvider>
                                    </Grid>
                                </Grid>
                                <Grid container sx={{marginBottom: "15px"}} spacing={1}>
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <Button type='button'
                                                variant='contained'
                                                color='secondary'
                                                onClick={() => handleClose(false)}
                                                style={{marginTop: "10px", marginRight: "6px"}}
                                                disabled={isSubmitting}
                                        >
                                            Cancel
                                        </Button>
                                        <LoadingButton type='submit'
                                                       variant='contained'
                                                       color='primary'
                                                       loading={isSubmitting}
                                                       style={{marginTop: "10px", marginRight: "5px"}}
                                        >
                                            Process
                                        </LoadingButton>
                                    </Grid>
                                </Grid>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default DelayTransferMembershipModal